import {
  Button,
  OutlinedSelect,
  SearchBox,
  useMobile,
} from "@octano/global-ui";
import { useForm } from "react-hook-form";
import { Col, Row } from "reactstrap";
import { useLeaveRequestsLoader } from "../Loaders/LeaveRequestsLoader";
import dayjs from "dayjs";
import DateInputOutlined from "components/DateInputOutlined";
import { useCallback } from "react";

enum ApprovedValues {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

interface FormValues {
  requestType: { label: string; value: string } | null;
  approved: { label: string; value: string } | null;
  requestBy: string;
  year: { label: string; value: string } | null;
  startDate: Date | null;
  endDate: Date | null;
}

const REQUEST_TYPE_OPTIONS = [
  { label: "Vacaciones", value: "Vacaciones" },
  { label: "Días administrativos", value: "Días administrativos" },
  { label: "Otros permisos", value: "Otros permisos" },
];

const APPROVED_OPTIONS = [
  { label: "Aprobada", value: ApprovedValues.Approved },
  { label: "Rechazada", value: ApprovedValues.Rejected },
  { label: "Pendiente", value: ApprovedValues.Pending },
];

const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => {
  const year = dayjs().year() - i;
  return { label: String(year), value: String(year) };
});

const DEFAULT_FORM_VALUES: FormValues = {
  requestType: null,
  approved: null,
  requestBy: "",
  year: null,
  startDate: null,
  endDate: null,
};
export function SearchControls() {
  const isMobile = useMobile();
  const { updateQuery } = useLeaveRequestsLoader();

  const { handleSubmit, control, reset } = useForm<FormValues>({
    defaultValues: DEFAULT_FORM_VALUES,
  });

  const handleSearch = (values: FormValues) => {
    console.log(values);

    const searchParams = {
      requestType: values.requestType?.value,
      approved: values.approved?.value,
      requestBy: values.requestBy || undefined,
      year: values.year?.value,
      startDate: values.startDate
        ? dayjs(values.startDate).format("YYYY-MM-DD")
        : undefined,
      endDate: values.endDate
        ? dayjs(values.endDate).format("YYYY-MM-DD")
        : undefined,
    };

    console.log(searchParams);

    updateQuery({
      page: 1,
      searchParams,
    });
  };

  const handleClear = useCallback(() => {
    reset({ ...DEFAULT_FORM_VALUES });
    updateQuery({ page: 1, searchParams: {} });
  }, [reset, updateQuery]);

  return (
    <form
      onSubmit={handleSubmit(handleSearch)}
      style={{ gap: isMobile ? 0 : 4 }}
    >
      <Row className="pb-4 gutters-filters">
        <Col xs={12} md={4} lg={3}>
          <OutlinedSelect
            control={control}
            name="requestType"
            label="Tipo de permiso"
            placeholder="Seleccionar"
            options={REQUEST_TYPE_OPTIONS}
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <OutlinedSelect
            control={control}
            name="approved"
            label="Estado"
            placeholder="Seleccionar"
            options={APPROVED_OPTIONS}
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <SearchBox
            name="requestBy"
            label="Solicitante"
            placeholder="Buscar por nombre"
            control={control}
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <OutlinedSelect
            control={control}
            name="year"
            label="Año"
            placeholder="Seleccionar"
            options={YEAR_OPTIONS}
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <DateInputOutlined
            name="startDate"
            control={control}
            label="Fecha inicio"
            placeholderText="dd/mm/aaaa"
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <DateInputOutlined
            name="endDate"
            control={control}
            label="Fecha fin"
            placeholderText="dd/mm/aaaa"
          />
        </Col>
        <Col xs={12} md={{ size: 3 }} lg={{ size: 2, offset: 2 }}>
          <Button type="submit" text="Buscar" size="md" fullwidth />
        </Col>
        <Col xs={12} md={{ size: 3 }} lg={2}>
          <Button
            type="button"
            text="Limpiar"
            size="md"
            fullwidth
            outlined
            onClick={handleClear}
          />
        </Col>
      </Row>
    </form>
  );
}
